import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form } from "formsy-semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { fetchVendorsList } from "../../actions/Vendors/vendors";

const SelectVendor = ({
  actions: { fetchItems },
  items,
  isFetching,
  required,
  error,
  minItemForSearch,
  onChange,
  native,
  ...extraProps
}) => {
  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const options = useMemo(
    () =>
      items
        .sort((c1, c2) => c1.name.localeCompare(c2.name))
        .map(content => ({
          key: content.id,
          text: content.name,
          value: content.id
        })),
    [items]
  );

  useEffect(() => {
    if (required && options && options.length === 1) {
      onChange(null, { options, value: options[0].value });
    }
  }, [options]); // eslint-disable-line

  const props = {
    placeholder: "Select client/buyer",
    fluid: true,
    ...extraProps,
    error,
    closeOnBlur: true,
    onChange,
    loading: isFetching,
    selection: true,
    required,
    search: options.length >= minItemForSearch,
    noResultsMessage: "Nothing was found",
    options
  };
  return native ? <Dropdown {...props} /> : <Form.Dropdown {...props} />;
};

SelectVendor.propTypes = {
  actions: PropTypes.object.isRequired,
  contractorsList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.object,
  minItemForSearch: PropTypes.bool,
  native: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  showArchived: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.number.isRequired
  ])
};

SelectVendor.defaultProps = {
  contractorsList: [],
  disabled: false,
  error: false,
  isFetching: false,
  minItemForSearch: 10,
  native: false,
  onChange: () => {},
  required: false
};

const mapStateToProps = ({
  vendors: {
    list: { content, isFetching }
  }
}) => {
  return {
    items: content,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchItems: fetchVendorsList
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectVendor);
